import {Glide, Controls, Breakpoints, Images, Swipe, Autoplay, Keyboard } from './carousel'

/**
 * Creates carousel bullet items
 * @param {jQuery} $parentEl container element
 */
export function createControls($parentEl) {
    const $carouselItems = $($parentEl).find('.glide__slide').not('.glide__slide--clone');
    let $carouselBullets = $($parentEl).find('[data-glide-el="controls[nav]"]');
    $carouselItems.each(function (index) {
        var $newIndiator = $(`<button class="glide__bullet" data-glide-dir="=${index}" aria-label="Slide ${index+1}"></button>`);
        $carouselBullets.append($newIndiator);
    });
    $carouselBullets.removeClass('d-none');
}

/**
 * Initialize carousel
 * @param {jQuery} $containerEl the wrapper element 
 * @param {Object} [options={}] - Configuration settings for the carousel (e.g., type, perView, rewind, gap etc.).
 * @param {boolean|jQuery} [$autoplay=false] - If `true`, enables autoplay.
 */
export function initializeCarousel($containerEl, options = {}, $autoplay=false) {
    const $carousel = $($containerEl);
    const $carouselItems = $($carousel).find('.glide__slide').not('.glide__slide--clone');
    const $controls = $($carousel).find('[data-glide-el="controls"]');
    const $bullets = $($carousel).find('[data-glide-el="controls[nav]"]');
    const totalSlides = $carouselItems.length;

    let glide;

    const handleUpdateEvent = () => {
        if (!glide) { return; }
        const { perView } = glide.settings;
        if (totalSlides <= perView) {
            $controls.addClass('d-none');
            $bullets.removeClass('d-flex').addClass('d-none');
            $($carousel).closest('.content-carousel-container').removeClass('active-slider');
        } else {
            $controls.removeClass('d-none');
            $bullets.removeClass('d-none').addClass('d-flex');
            $($carousel).closest('.content-carousel-container').addClass('active-slider');
        }
    }

    glide = new Glide($carousel.get(0), options)
        .on('build.before', handleUpdateEvent)
        .mount({
            Controls,
            Breakpoints,
            Swipe,
            Images,
            Keyboard,
            ...($autoplay && {Autoplay}),
        });
    
    handleUpdateEvent()
}